import { connect } from 'react-redux';
import Menu from 'comp/left/app_tabs';
import * as selectors from 'selectors';

const mapToProps = state => ({
  selected_tab: state.ui.selected_app_tab,
  unred_count: {
    GROUPS: selectors.getUnreadGroupCount(),
    PM: selectors.getUnreadPMCount()
  }
});

export default connect(mapToProps)(Menu);



// WEBPACK FOOTER //
// ./src/containers/left/AppTabs.js